import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IdentificationOfConsensusResiduesComponent from '../components/identificationOfConsensusResiduesComponent';
import IAppState from '../../../IAppState';
import ActMain from '../../../act-main';
import ActSummary from '../../SummaryPage/state/act-summary';
import { clientUrlPrefix } from '../../../settings';
import {
    IIdentificationOfConsensusResiduesData,
    IIdentificationOfConsensusResiduesFunctions,
} from '../props/IIdentificationOfConsensusResiduesProps';


interface IOwnProps {
    ecNumber?: string;
    choice;
    customQuery?: boolean;
    history: any;
}

const mapStateToProps = (
    { mainState }: IAppState,
    ownProps: IOwnProps
): IIdentificationOfConsensusResiduesData => {
    return {

        ...mainState,
        majorityConsensusMinIdentity : mainState.advancedOptions.majorityConsensusMinIdentity,
        ratioConsensusMinFreq: mainState.advancedOptions.ratioConsensusMinFreq,
        ratioConsensusMinRatio: mainState.advancedOptions.ratioConsensusMinRatio,
        globalConsensusGapThreshold: mainState.advancedOptions.globalConsensusGapThreshold,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IOwnProps
): IIdentificationOfConsensusResiduesFunctions => ({
    changeMajorityConsensusMinIdentity: (majorityConsensusMinIdentity: number ) => dispatch(ActMain.changeMajorityConsensusMinIdentity(majorityConsensusMinIdentity)),
    changeRatioConsensusMinFreq : (ratioConsensusMinFreq: number ) => dispatch(ActMain.changeRatioConsensusMinFreq (ratioConsensusMinFreq)),
    changeRatioConsensusMinRatio : (ratioConsensusMinRatio: number ) => dispatch(ActMain.changeRatioConsensusMinRatio(ratioConsensusMinRatio)),
    changeGlobalConsensusGapThreshold : (globalConsensusGapThreshold: number ) => dispatch(ActMain.changeGlobalConsensusGapThreshold(globalConsensusGapThreshold)),
});

const IdentificationOfConsensusResiduesContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(IdentificationOfConsensusResiduesComponent)
);
export default IdentificationOfConsensusResiduesContainer;
